import { __styles } from '@griffel/react';
import { tokens } from '@fluentui/react-theme';
export const useStyles = /*#__PURE__*/__styles({
  wrapper: {
    mc9l5x: "fjseox",
    Bqenvij: "fniina8",
    a9b677: "f3tsq5r",
    Bkecrkj: "f1aehjj5"
  },
  wrapperActive: {
    mc9l5x: "ftgm304"
  },
  svg: {
    Bkfmm31: "f1au8mb3",
    Bkecrkj: "f1aehjj5",
    qhf8xq: "f19dog8a",
    Bhzewxz: "f15twtuk",
    oyh7mz: ["f1vgc2s3", "f1e31b4d"]
  },
  triangle: {
    Bkecrkj: "f1cguypg"
  },
  triangleDebug: {
    Bceei9c: "f7116n6",
    Bkfmm31: "f1xab38x"
  },
  rectDebug: {
    Bkfmm31: "fyegryc"
  }
}, {
  d: [".fjseox{display:none;}", ".fniina8{height:0;}", ".f3tsq5r{width:0;}", ".f1aehjj5{pointer-events:none;}", ".ftgm304{display:block;}", ".f1au8mb3{fill:transparent;}", ".f19dog8a{position:fixed;}", ".f15twtuk{top:0;}", ".f1vgc2s3{left:0;}", ".f1e31b4d{right:0;}", ".f1cguypg{pointer-events:auto;}", ".f7116n6{cursor:crosshair;}", ".f1xab38x{fill:color-mix(in srgb, var(--colorPaletteGreenBackground3) 20%, transparent);}", ".fyegryc{fill:color-mix(in srgb, var(--colorPaletteRedBackground3) 20%, transparent);}"]
});